/**
 * Main entry point for the Vue.js application.
 * Initializes DevExtreme themes, sets up the Vue app with router,
 * and configures global properties.
 */

import 'devextreme/dist/css/dx.common.css';
import './themes/generated/theme.base.css';
import './themes/generated/theme.additional.css';
import { createApp } from "vue";
import router from "./router";
import themes from "devextreme/ui/themes";

import App from "./App";
import appInfo from "./app-info";

// Ensure DevExtreme themes are loaded before mounting the app
themes.initialized(() => {
    try {
        const app = createApp(App);
        app.use(router);

        // Make app info globally accessible in components
        app.config.globalProperties.$appInfo = appInfo;

        app.mount('#app');
    } catch (error) {
        console.error('Failed to initialize Vue app:', error);
        // Optional: Add fallback UI or error reporting
    }
});
